import { render, staticRenderFns } from "./AttachmentPreviewItem.vue?vue&type=template&id=254de62f&scoped=true"
import script from "./AttachmentPreviewItem.vue?vue&type=script&lang=js"
export * from "./AttachmentPreviewItem.vue?vue&type=script&lang=js"
import style0 from "./AttachmentPreviewItem.vue?vue&type=style&index=0&id=254de62f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254de62f",
  null
  
)

export default component.exports